import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { AccessGate } from '../components/ui/AccessGate';

export const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO title="Access Denied" noindex={true} />
      <AccessGate
        reason="permission"
        resolveLabel="Go to Dashboard"
        onResolve={() => navigate('/dashboard')}
      />
    </>
  );
};
